import { WMCodesLookupLayout, WMTransactionDPLookupLayout, WMChargeDpLookupLayout, WMRateTableHeaderLookupLayout } from "../../../../common/lookups/Layouts/WMLayouts";
import { AccountLookup, ACDepartmentLayout } from "../../../../common/lookups/Layouts/ACLayouts";
import { FAFundLayout } from "../../../../common/lookups/Layouts/FALayouts";
import { CAJobLayout, ActivityLayout } from "../../../../common/lookups/Layouts/CALayouts";
import { EDLookupLayout } from '../../../../common/lookups/Layouts/EDLayouts';

const userDefinedCode1Layout = WMCodesLookupLayout({ codeType: '36' });
const userDefinedCode2Layout = WMCodesLookupLayout({ codeType: '37' });
const userDefinedCode3Layout = WMCodesLookupLayout({ codeType: '38' });
const userDefinedCode4Layout = WMCodesLookupLayout({ codeType: '39' });
const userDefinedCode5Layout = WMCodesLookupLayout({ codeType: '40' });
const userDefinedCode6Layout = WMCodesLookupLayout({ codeType: '41' });
const userDefinedCode7Layout = WMCodesLookupLayout({ codeType: '42' });
const userDefinedCode8Layout = WMCodesLookupLayout({ codeType: '43' });
const userDefinedCode9Layout = WMCodesLookupLayout({ codeType: '44' });
const userDefinedCode10Layout = WMCodesLookupLayout({ codeType: '45' });
const chargeUomLayout = EDLookupLayout({ Dataelementnum: '122', Versionid: '4010' });

export const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RECORD",
                "localizedField": "KEYSEQUENCE",
                "tableName": "WMCHARGES",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_PROFILE",
                "tableName": "WMCHARGES",
                "label": "Profile",
                "type": "lookup",
                "layout": WMChargeDpLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CHARGECODE",
                "tableName": "WMCHARGES",
                "label": "Charge Code",
                "type": "text",
                "required": true,
                "maxLength": 10,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DESCRIPTION1",
                "tableName": "WMCHARGES",
                "label": "Description 1",
                "type": "text",
                "maxLength": 40,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DESCRIPTION2",
                "tableName": "WMCHARGES",
                "label": "Description 2",
                "type": "text",
                "maxLength": 40,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CHARGETYPE",
                "tableName": "WMCHARGES",
                "label": "Charge Type",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "revenueGroup",
                "tableName": "",
                "label": "Revenue Group",
                "type": "lookup",
                 layout: WMCodesLookupLayout({ codeType: '01' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "COMMENT",
                "tableName": "WMCHARGES",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } 
        ]
    }
];

export const UserDefinedLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDCODE_1",
                "localizedField": "USERDEFINEDCODE_1",
                "tableName": "WMCHARGES",
                "label": "Code 1",
                "type": "lookup",
                "layout": userDefinedCode1Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_2",
                "localizedField": "USERDEFINEDCODE_2",
                "tableName": "WMCHARGES",
                "label": "Code 2",
                "type": "lookup",
                "layout": userDefinedCode2Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_3",
                "localizedField": "USERDEFINEDCODE_3",
                "tableName": "WMCHARGES",
                "label": "Code 3",
                "type": "lookup",
                "layout": userDefinedCode3Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_4",
                "localizedField": "USERDEFINEDCODE_4",
                "tableName": "WMCHARGES",
                "label": "Code 4",
                "type": "lookup",
                "layout": userDefinedCode4Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_5",
                "localizedField": "USERDEFINEDCODE_5",
                "tableName": "WMCHARGES",
                "label": "Code 5",
                "type": "lookup",
                "layout": userDefinedCode5Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_6",
                "localizedField": "USERDEFINEDCODE_6",
                "tableName": "WMCHARGES",
                "label": "Code 6",
                "type": "lookup",
                "layout": userDefinedCode6Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_7",
                "localizedField": "USERDEFINEDCODE_7",
                "tableName": "WMCHARGES",
                "label": "Code 7",
                "type": "lookup",
                "layout": userDefinedCode7Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_8",
                "localizedField": "USERDEFINEDCODE_8",
                "tableName": "WMCHARGES",
                "label": "Code 8",
                "type": "lookup",
                "layout": userDefinedCode8Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_9",
                "localizedField": "USERDEFINEDCODE_9",
                "tableName": "WMCHARGES",
                "label": "Code 9",
                "type": "lookup",
                "layout": userDefinedCode9Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_10",
                "localizedField": "USERDEFINEDCODE_10",
                "tableName": "WMCHARGES",
                "label": "Code 10",
                "type": "lookup",
                "layout": userDefinedCode10Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDDATE_1",
                "localizedField": "USERDEFINEDDATE_1",
                "tableName": "WMCHARGES",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_2",
                "localizedField": "USERDEFINEDDATE_2",
                "tableName": "WMCHARGES",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_3",
                "localizedField": "USERDEFINEDDATE_3",
                "tableName": "WMCHARGES",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_4",
                "localizedField": "USERDEFINEDDATE_4",
                "tableName": "WMCHARGES",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_5",
                "localizedField": "USERDEFINEDDATE_5",
                "tableName": "WMCHARGES",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_6",
                "localizedField": "USERDEFINEDDATE_6",
                "tableName": "WMCHARGES",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_7",
                "localizedField": "USERDEFINEDDATE_7",
                "tableName": "WMCHARGES",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_8",
                "localizedField": "USERDEFINEDDATE_8",
                "tableName": "WMCHARGES",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_9",
                "localizedField": "USERDEFINEDDATE_9",
                "tableName": "WMCHARGES",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_10",
                "localizedField": "USERDEFINEDDATE_10",
                "tableName": "WMCHARGES",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDQUANTITY_1",
                "localizedField": "USERDEFINEDQUANTITY_1",
                "tableName": "WMCHARGES",
                "label": "Quantity 1",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_2",
                "localizedField": "USERDEFINEDQUANTITY_2",
                "tableName": "WMCHARGES",
                "label": "Quantity 2",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_3",
                "localizedField": "USERDEFINEDQUANTITY_3",
                "tableName": "WMCHARGES",
                "label": "Quantity 3",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_4",
                "localizedField": "USERDEFINEDQUANTITY_4",
                "tableName": "WMCHARGES",
                "label": "Quantity 4",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_5",
                "localizedField": "USERDEFINEDQUANTITY_5",
                "tableName": "WMCHARGES",
                "label": "Quantity 5",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_6",
                "localizedField": "USERDEFINEDQUANTITY_6",
                "tableName": "WMCHARGES",
                "label": "Quantity 6",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_7",
                "localizedField": "USERDEFINEDQUANTITY_7",
                "tableName": "WMCHARGES",
                "label": "Quantity 7",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_8",
                "localizedField": "USERDEFINEDQUANTITY_8",
                "tableName": "WMCHARGES",
                "label": "Quantity 8",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_9",
                "localizedField": "USERDEFINEDQUANTITY_9",
                "tableName": "WMCHARGES",
                "label": "Quantity 9",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_10",
                "localizedField": "USERDEFINEDQUANTITY_10",
                "tableName": "WMCHARGES",
                "label": "Quantity 10",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];

export const ReferencesLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDREFERENCE_1",
                "localizedField": "USERDEFINEDREFERENCE_1",
                "tableName": "WMCHARGES",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_2",
                "localizedField": "USERDEFINEDREFERENCE_2",
                "tableName": "WMCHARGES",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_3",
                "localizedField": "USERDEFINEDREFERENCE_3",
                "tableName": "WMCHARGES",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_4",
                "localizedField": "USERDEFINEDREFERENCE_4",
                "tableName": "WMCHARGES",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_5",
                "localizedField": "USERDEFINEDREFERENCE_5",
                "tableName": "WMCHARGES",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDREFERENCE_6",
                "localizedField": "USERDEFINEDREFERENCE_6",
                "tableName": "WMCHARGES",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_7",
                "localizedField": "USERDEFINEDREFERENCE_7",
                "tableName": "WMCHARGES",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_8",
                "localizedField": "USERDEFINEDREFERENCE_8",
                "tableName": "WMCHARGES",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_9",
                "localizedField": "USERDEFINEDREFERENCE_9",
                "tableName": "WMCHARGES",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDREFERENCE_10",
                "localizedField": "USERDEFINEDREFERENCE_10",
                "tableName": "WMCHARGES",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDCOMMENT",
                "localizedField": "USERDEFINEDCOMMENT",
                "tableName": "WMCHARGES",
                "label": "User Defined Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];

export const AccountingLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "R_GLACCOUNT",
                "localizedField": "R_GLACCOUNT",
                "tableName": "WMCHARGES",
                "label": "Account",
                "type": "lookup",
                "layout": AccountLookup,
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            },
            
            {
                "name": "R_CAACTIVITY",
                "localizedField": "R_CAACTIVITY",
                "tableName": "WMCHARGES",
                "label": "CA Activity",
                "type": "lookup",
                "layout": ActivityLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
            ,
            {
                "name": "MANAGEMENTSOURCE",
                "tableName": "WMCHARGES",
                "label": "Mgmt Unit",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_GLDEPARTMENT",
                "localizedField": "R_GLDEPARTMENT",
                "tableName": "WMCHARGES",
                "label": "Department",
                "type": "lookup",
                "layout": ACDepartmentLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_FAFUND",
                "localizedField": "R_FAFUND",
                "tableName": "WMCHARGES",
                "label": "Fund",
                "type": "lookup",
                "layout": FAFundLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_CAJOB",
                "localizedField": "R_CAJOB",
                "tableName": "WMCHARGES",
                "label": "Job",
                "type": "lookup",
                "layout": CAJobLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
];

export const StorageLayout = [
    {
        "groupId": 1,
        "label": "Recurring Storage",
        "fields": [
            {
                "name": "STORAGETIMING",
                "tableName": "WMCHARGES",
                "label": "Timing",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STORAGEFREQUENCY",
                "tableName": "WMCHARGES",
                "label": "Frequency",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];

export const BillingLayout = [
    {
        "groupId": 1,
        "label": "Miscellaneous",
        "fields": [
            {
                "name": "STATUS",
                "tableName": "WMCHARGES",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "TAXABLE",
                "tableName": "WMCHARGES",
                "label": "Taxable",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DISCOUNTABLE",
                "tableName": "WMCHARGES",
                "label": "Discountable",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "Bill As Quantity Charge Basis",
        "fields": [
            {
                "name": "BILLINGMETHOD",
                "tableName": "WMCHARGES",
                "label": "Billing Method",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CHARGEBASISUNITS",
                "tableName": "WMCHARGES",
                "label": "Basis",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ROUNDING",
                "tableName": "WMCHARGES",
                "label": "Rounding",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ACCESSBILLAS",
                "tableName": "WMCHARGES",
                "label": "Allow Access",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "BILLASMINIMUMQUANTITY",
                "tableName": "WMCHARGES",
                "label": "Minimum Unit",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CHARGEBASISLEVEL",
                "tableName": "WMCHARGES",
                "label": "Level",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "Rate Charge Basis",
        "fields": [
            {
                "name": "CHARGEUOM",
                "localizedField": "CHARGEUOM",
                "tableName": "WMCHARGES",
                "label": "ChargeUOM",
                "type": "lookup",
                "layout": chargeUomLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RATESOURCE",
                "tableName": "WMCHARGES",
                "label": "Rate Source",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UNITCHARGERATE",
                "tableName": "WMCHARGES",
                "label": "Charge Rate",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_RATETABLE",
                "tableName": "WMCHARGES",
                "label": "Rate Table",
                "type": "lookup",
                "layout": WMRateTableHeaderLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "RATETABLEQUANTITYBASIS",
                "tableName": "WMCHARGES",
                "label": "Qty Basis",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CUMULATIVERATE",
                "tableName": "WMCHARGES",
                "label": "Cumulative",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "UNITCHARGEFACTOR",
                "tableName": "WMCHARGES",
                "label": "Charge Factor",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "MINIMUMCHARGEAMOUNT",
                "tableName": "WMCHARGES",
                "label": "Minimum Amt",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "MAXIMUMCHARGEAMOUNT",
                "tableName": "WMCHARGES",
                "label": "Maximum Amt",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];

export const SearchLayout = [
    {
        "groupId": 1,
        "fields": [
            {
                "name": "chargeCode",
                "tableName": "IMITEM",
                "label": "Charge Code",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "fields": [
            {
                "name": "description1",
                "tableName": "WMCHARGES",
                "label": "Description 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "fields": [
            {
                "name": "description2",
                "tableName": "WMCHARGES",
                "label": "Description 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "fields": [
            {
                "name": "chargeType",
                "tableName": "",
                "label": "Type",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 5,
        "fields": [
            {
                "name": "storageTiming",
                "tableName": "WMCHARGES",
                "label": "Storage Timing",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 6,
        "fields": [
            {
                "name": "rateTableQuantityBasis",
                "tableName": "WMCHARGES",
                "label": "Quantity Basis",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 7,
        "fields": [
            {
                "name": "progressiveRateBasis",
                "tableName": "WMCHARGES",
                "label": "Progressive",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 8,
        "fields": [
            {
                "name": "billingFlag",
                "tableName": "WMCHARGES",
                "label": "Billing",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 9,
        "fields": [
            {
                "name": "status",
                "tableName": "WMCHARGES",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 10,
        "fields": [
            {
                "name": "managementSource",
                "tableName": "WMCHARGES",
                "label": "Mgmt Unit",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 11,
        "fields": [
            {
                "name": "taxable",
                "tableName": "WMCHARGES",
                "label": "Taxable",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 12,
        "fields": [
            {
                "name": "discountable",
                "tableName": "WMCHARGES",
                "label": "Discountable",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 13,
        "fields": [
            {
                "name": "commissionable",
                "tableName": "WMCHARGES",
                "label": "Commission",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 14,
        "fields": [
            {
                "name": "chargeBasisLevel",
                "tableName": "WMCHARGES",
                "label": "Level",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 15,
        "fields": [
            {
                "name": "rateSource",
                "tableName": "WMCHARGES",
                "label": "Rate Source",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 16,
        "fields": [
            {
                "name": "revenueGroup",
                "tableName": "",
                "label": "Revenue Group",
                "type": "lookup",
                 layout: WMCodesLookupLayout({ codeType: '01' }),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 17,
        "fields": [
            {
                "name": "frequency",
                "tableName": "",
                "label": "Frequency",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } 
        ]
    },
    {
        "groupId": 18,
        "fields": [
            {
                "name": "applyMinAmtOnFreeDays",
                "tableName": "WMCHARGES",
                "label": "Apply Min Amt",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 19,
        "fields": [
            {
                "name": "chargeUom",
                "tableName": "WMCHARGES",
                "label": "Charge UOM",
                "type": "lookup",
                "layout": chargeUomLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 20,
        "fields": [
            {
                "name": "maximumChargeAmount",
                "tableName": "WMCHARGES",
                "label": "Maximum Amount",
                "type": "number",
                "format": "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 21,
        "fields": [
            {
                "name": "dateAdjustmentDays",
                "tableName": "WMCHARGES",
                "label": "# Of Days",
                "type": "number",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 22,
        "fields": [
            {
                "name": "storageAvgDailyBal",
                "tableName": "WMCHARGES",
                "label": "Avg Daily Bal",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 23,
        "fields": [
            {
                "name": "storageBeginDate",
                "tableName": "WMCHARGES",
                "label": "Start Period",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 24,
        "fields": [
            {
                "name": "storageLastMonth",
                "tableName": "WMCHARGES",
                "label": "Last Month",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 25,
        "fields": [
            {
                "name": "storageFirstMonth",
                "tableName": "WMCHARGES",
                "label": "First Month",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 26,
        "fields": [
            {
                "name": "dateAdjustment",
                "tableName": "WMCHARGES",
                "label": "Date Adjustment",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 27,
        "fields": [
            {
                "name": "chargeBasisUnits",
                "tableName": "WMCHARGES",
                "label": "Charge Basis Units",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 28,
        "fields": [
            {
                "name": "unitChargeRate",
                "tableName": "WMCHARGES",
                "label": "Charge Rate",
                "type": "number",
                "format": "#,##0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 29,
        "fields": [
            {
                "name": "userDefinedCode1",
                "tableName": "WMCHARGES",
                "label": "Code 1",
                "type": "lookup",
                "layout": userDefinedCode1Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 30,
        "fields": [
            {
                "name": "userDefinedCode2",
                "tableName": "WMCHARGES",
                "label": "Code 2",
                "type": "lookup",
                "layout": userDefinedCode2Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 31,
        "fields": [
            {
                "name": "userDefinedCode3",
                "tableName": "WMCHARGES",
                "label": "Code 3",
                "type": "lookup",
                "layout": userDefinedCode3Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 32,
        "fields": [
            {
                "name": "userDefinedCode4",
                "tableName": "WMCHARGES",
                "label": "Code 4",
                "type": "lookup",
                "layout": userDefinedCode4Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 33,
        "fields": [
            {
                "name": "userDefinedCode5",
                "tableName": "WMCHARGES",
                "label": "Code 5",
                "type": "lookup",
                "layout": userDefinedCode5Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 34,
        "fields": [
            {
                "name": "userDefinedCode6",
                "tableName": "WMCHARGES",
                "label": "Code 6",
                "type": "lookup",
                "layout": userDefinedCode6Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 35,
        "fields": [
            {
                "name": "userDefinedCode7",
                "tableName": "WMCHARGES",
                "label": "Code 7",
                "type": "lookup",
                "layout": userDefinedCode7Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 36,
        "fields": [
            {
                "name": "userDefinedCode8",
                "tableName": "WMCHARGES",
                "label": "Code 8",
                "type": "lookup",
                "layout": userDefinedCode8Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 37,
        "fields": [
            {
                "name": "userDefinedCode9",
                "tableName": "WMCHARGES",
                "label": "Code 9",
                "type": "lookup",
                "layout": userDefinedCode9Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 38,
        "fields": [
            {
                "name": "userDefinedCode10",
                "tableName": "WMCHARGES",
                "label": "Code 10",
                "type": "lookup",
                "layout": userDefinedCode10Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 39,
        "fields": [
            {
                "name": "userDefinedDate1",
                "tableName": "WMCHARGES",
                "label": "Date 1",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 40,
        "fields": [
            {
                "name": "userDefinedDate2",
                "tableName": "WMCHARGES",
                "label": "Date 2",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 41,
        "fields": [
            {
                "name": "userDefinedDate3",
                "tableName": "WMCHARGES",
                "label": "Date 3",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 42,
        "fields": [
            {
                "name": "userDefinedDate4",
                "tableName": "WMCHARGES",
                "label": "Date 4",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 43,
        "fields": [
            {
                "name": "userDefinedDate5",
                "tableName": "WMCHARGES",
                "label": "Date 5",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 44,
        "fields": [
            {
                "name": "userDefinedDate6",
                "tableName": "WMCHARGES",
                "label": "Date 6",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 45,
        "fields": [
            {
                "name": "userDefinedDate7",
                "tableName": "WMCHARGES",
                "label": "Date 7",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 46,
        "fields": [
            {
                "name": "userDefinedDate8",
                "tableName": "WMCHARGES",
                "label": "Date 8",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 47,
        "fields": [
            {
                "name": "userDefinedDate9",
                "tableName": "WMCHARGES",
                "label": "Date 9",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 48,
        "fields": [
            {
                "name": "userDefinedDate10",
                "tableName": "WMCHARGES",
                "label": "Date 10",
                "type": "date",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 49,
        "fields": [
            {
                "name": "userDefinedReference1",
                "tableName": "WMCHARGES",
                "label": "Reference 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 50,
        "fields": [
            {
                "name": "userDefinedReference2",
                "tableName": "WMCHARGES",
                "label": "Reference 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 51,
        "fields": [
            {
                "name": "userDefinedReference3",
                "tableName": "WMCHARGES",
                "label": "Reference 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 52,
        "fields": [
            {
                "name": "userDefinedReference4",
                "tableName": "WMCHARGES",
                "label": "Reference 4",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 53,
        "fields": [
            {
                "name": "userDefinedReference5",
                "tableName": "WMCHARGES",
                "label": "Reference 5",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 54,
        "fields": [
            {
                "name": "userDefinedReference6",
                "tableName": "WMCHARGES",
                "label": "Reference 6",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 55,
        "fields": [
            {
                "name": "userDefinedReference7",
                "tableName": "WMCHARGES",
                "label": "Reference 7",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 56,
        "fields": [
            {
                "name": "userDefinedReference8",
                "tableName": "WMCHARGES",
                "label": "Reference 8",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 57,
        "fields": [
            {
                "name": "userDefinedReference9",
                "tableName": "WMCHARGES",
                "label": "Reference 9",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 58,
        "fields": [
            {
                "name": "userDefinedReference10",
                "tableName": "WMCHARGES",
                "label": "Reference 10",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];

